function injectStyle (ssrContext) {
  require("!!../../../../node_modules/.store/extract-text-webpack-plugin@2.0.0/node_modules/extract-text-webpack-plugin/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"minimize\":true,\"sourceMap\":true}!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-c7d888a6\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=styles&index=0!./toast.vue")
}
var Component = require("!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=script&index=0!./toast.vue"),
  /* template */
  require("!!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-c7d888a6\"}!../../../../node_modules/.store/vue-loader@12.1.0/node_modules/vue-loader/lib/selector?type=template&index=0!./toast.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-c7d888a6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/common/bdToast/toast.vue
// module id = 945
// module chunks = 76